import { all } from "redux-saga/effects";
import authSaga from "./Sagas/auth/auth-saga";
import userManagementSaga from "./Sagas/user-management/user-management-saga";
import cmsSaga from "./Sagas/cms/cms-saga";
import profileSaga from "./Sagas/profile/profile-saga";
import settingsSaga from "./Sagas/settings/settings-saga";
import dashboardSaga from "./Sagas/dashboard/dashboard-saga";
import categoryManagementSaga from "./Sagas/category-management/category-management-saga";
import curriculumManagementSaga from "./Sagas/curriculum-management/curriculum-management-saga";
import productManagementSaga from "./Sagas/product-management/product-management-saga";
import mainModuleManagementSaga from "./Sagas/main-module-management/main-module-management-saga";
import schoolManagementSaga from "./Sagas/school-management/school-management-saga";
import exportManagementSaga from "./Sagas/school-management/export-management-saga";
import codeManageMentSaga from "./Sagas/code-management/code-management-saga";
import headingManagementSaga from "./Sagas/heading/heading-management-saga";
import glbFileSaga from "./Sagas/glb-upload/glb-saga";
import jsonFileSaga from "./Sagas/json-upload/json-saga";
import viewJsonSaga from "./Sagas/json-view/viewjson-saga";
import ModuleSaga from "./Sagas/modules/module-saga";
import ModuleListSaga from "./Sagas/modules/moduleList-saga";
import PermissionSaga from "./Sagas/permission/permission-saga";

export default function* rootSaga() {
  yield all([
    authSaga(),
    userManagementSaga(),
    cmsSaga(),
    profileSaga(),
    settingsSaga(),
    dashboardSaga(),
    categoryManagementSaga(),
    curriculumManagementSaga(),
    productManagementSaga(),
    mainModuleManagementSaga(),
    schoolManagementSaga(),
    exportManagementSaga(),
    codeManageMentSaga(),
    headingManagementSaga(),
    glbFileSaga(),
    jsonFileSaga(),
    viewJsonSaga(),
    ModuleSaga(),
    ModuleListSaga(),
    PermissionSaga(),
  ]);
}
